import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MapPlace } from '../models/MapPlace';
import { MapV2Service } from '../mapv2.service';
import { Subject } from 'rxjs';
import { MapView } from '../models/Map';

@Component({
  selector: 'mapv2-cart',
  templateUrl: './mapv2-cart.component.html',
  styleUrls: ['./mapv2-cart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MapV2CartComponent implements OnInit, OnDestroy {
  public selectedPlaces!: MapPlace[];
  private unsubscribe$: Subject<void>;

  constructor(
    private service: MapV2Service
  ) {
    this.unsubscribe$ = new Subject();
  }

  public ngOnInit(): void {
    const cart = this.service.getCart();
    this.selectedPlaces = cart.places;
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  public deletePlace(place: MapPlace): void {
    this.service.cancelReserve(place)
      .then(() => {
        this.service.setView(MapView.PLACES);
      });
  }
}
